const Divider = (): JSX.Element => {
    return <div className="h-px w-full bg-greyscale-100" />;
};

export default Divider;
